(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('ckCartForm');
    if (!form) return;

    // Debounce helper
    function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }

    function updateQuantity(key, qty) {
      qty = Math.max(0, parseInt(qty, 10) || 0);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.reload();
      }).catch(function () { window.location.reload(); });
    }

    // Steppers
    form.querySelectorAll('.qty-stepper').forEach(function (stepper) {
      var input = stepper.querySelector('input');
      var key = stepper.getAttribute('data-key');
      stepper.querySelector('.qty-inc').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 0) + 1;
        updateQuantity(key, input.value);
      });
      stepper.querySelector('.qty-dec').addEventListener('click', function () {
        var v = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        input.value = v;
        updateQuantity(key, v);
      });
      input.addEventListener('change', debounce(function () {
        updateQuantity(key, input.value);
      }, 250));
    });

    // Remove
    form.querySelectorAll('.remove-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-remove-key');
        updateQuantity(key, 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
